import React, { useEffect, useState } from 'react';
import Button from '../Button';

import Logo from '../../assets/img/logo/logo-black-2.png';
import shopPopUpImg from '../../assets/img/shop/shop-popup.png';

const SubscribeModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Set a timer to open the modal after 2 seconds
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={isModalOpen ? 'subscribe-popup show' : 'subscribe-popup'}>
      <div className="it-shop-popup-wrap">
        <div className="it-shop-popup-img d-none d-lg-block">
          <img src={shopPopUpImg} alt="" />
        </div>
        <div className="it-shop-popup-content text-center">
          <div className="close" onClick={() => closeModal()}>
            <i className="fa-light fa-xmark"></i>
          </div>
          <div className="it-shop-popup-logo mx-md-auto">
            <img src={Logo} alt="" />
          </div>
          <div className="it-shop-popup-text">
            <h4>Save 15%</h4>
            <p>ON TODAYS ORDER</p>
            <span>SIGN UP BELOW FOR DISCOUNT CODE</span>
          </div>
          <form action="#">
            <div className="it-shop-popup-inputbox">
              <input type="text" placeholder="Email Address" />
              <button
                className="it-btn-theme d-flex justify-content-center align-items-center black-bg w-100"
                type="submit"
              >
                <Button btnText="Subscribe" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubscribeModal;
